<template>
  <div class="canteenInfo">
    <el-form ref="canteenForm" :model="canteenForm" class="canteenForm" label-width="165px" label-position="left" :rules="rule_data" :hide-required-asterisk="true">
      <el-form-item prop="schoolQualiProof">
        <template slot="label"><div><span class="canteenRequired">*</span>学校资质证明
          <el-tooltip class="item" effect="light" placement="left-end" popper-class="canteenTooltip">
            <div slot="content" class="tooltipDiv">
              自营食堂（结算主体为学校/XX学校食堂/XX学校后勤中心）<br/>
              ----公立学校食堂需提供：《事业单位法人登记证书》或者事业单位在线网截图；<br/>
              ----民办学校食堂需提供：《民办非企业法人登记证书》或者全国社会组织信息<br/>截图或工商登记局截图；
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </div><span>(最少1张，最多5张)</span></template>
        <multi-upload :value="canteenForm.schoolQualiProof" valueName="schoolQualiProof" :limit="5" :otherData="{type:'schoolQualiProof'}" @uploaded="multiUploaded" @delete="multiDelete"></multi-upload>
      </el-form-item>
      <el-divider></el-divider>
      <el-form-item prop="coopQualiProof">
        <template slot="label"><div><span class="canteenRequired">*</span>合作资质证明
          <el-tooltip class="item" effect="light" placement="left-end" popper-class="canteenTooltip">
            <div slot="content" class="tooltipDiv">
              自营食堂（结算主体为学校/XX学校食堂/XX学校后勤中心）<br/>
              ----公立学校食堂需提供：《事业单位法人登记证书》或者事业单位在线网截图；<br/>
              ----民办学校食堂需提供：《民办非企业法人登记证书》或者全国社会组织信息<br/>截图或工商登记局截图；
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip></div><span>(最少1张，最多5张)</span></template>
        <multi-upload :value="canteenForm.coopQualiProof" valueName="coopQualiProof" :limit="5" :otherData="{type:'coopQualiProof'}"  @uploaded="multiUploaded" @delete="multiDelete"></multi-upload>
      </el-form-item>
      <el-divider></el-divider>
      <el-form-item prop="preferRateCommitLetter">
        <template slot="label"><div><span class="canteenRequired">*</span>优惠费率承诺函
          <el-tooltip class="item" effect="light"  placement="left-end" popper-class="canteenTooltip">
            <div slot="content">
              自营食堂（结算主体为学校/XX学校食堂/XX学校后勤中心）<br/>
              ----公立学校食堂需提供：《事业单位法人登记证书》或者事业单位在线网截图；<br/>
              ----民办学校食堂需提供：《民办非企业法人登记证书》或者全国社会组织信息<br/>截图或工商登记局截图；
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </div><span>(最少1张，最多5张)</span></template>
        <multi-upload :value="canteenForm.preferRateCommitLetter" valueName="preferRateCommitLetter" :limit="5" :otherData="{type:'preferRateCommitLetter'}"  @uploaded="multiUploaded" @delete="multiDelete"></multi-upload>
      </el-form-item>
      <el-divider></el-divider>
      <el-form-item prop="diningEnvironmentPhotos">
        <template slot="label"><div><span class="canteenRequired">*</span>食堂内部用餐环境照片</div><span>(最少1张，最多5张)</span></template>
        <multi-upload :value="canteenForm.diningEnvironmentPhotos" valueName="diningEnvironmentPhotos" :limit="5" :otherData="{type:'diningEnvironmentPhotos'}"  @uploaded="multiUploaded" @delete="multiDelete"></multi-upload>
      </el-form-item>
      <el-divider></el-divider>
      <el-form-item prop="canteenDoorPhotos">
        <template slot="label"><div><span class="canteenRequired">*</span>食堂门头照片</div><span>(最少1张，最多5张)</span></template>
        <multi-upload :value="canteenForm.canteenDoorPhotos" valueName="canteenDoorPhotos" :limit="5" :otherData="{type:'canteenDoorPhotos'}"  @uploaded="multiUploaded" @delete="multiDelete"></multi-upload>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import multiUpload from '@/components/upload/multiUpload'
export default {
  components: {
    multiUpload
  },
  props: {
    canteenForm: {
      type: Object,
      default: function () {
        return {
          canteenDoorPhotos: '',
          coopQualiProof: '',
          diningEnvironmentPhotos: '',
          preferRateCommitLetter: '',
          schoolQualiProof: ''
        }
      }
    }
  },
  data () {
    return {
      rule_data: {
        schoolQualiProof: [{
          required: true,
          message: '请上传学校资质证明',
          trigger: 'change'
        }],
        coopQualiProof: [{
          required: true,
          message: '请上传合作资质证明',
          trigger: 'change'
        }],
        preferRateCommitLetter: [{
          required: true,
          message: '请上传优惠费率承诺函',
          trigger: 'change'
        }],
        diningEnvironmentPhotos: [{
          required: true,
          message: '请上传食堂内部用餐环境照片',
          trigger: 'change'
        }],
        canteenDoorPhotos: [{
          required: true,
          message: '请上传食堂门头照片',
          trigger: 'change'
        }]
      }
    }
  },
  methods: {
    // 批量上传成功回调
    multiUploaded (data) {
      const that = this
      if (!that.canteenForm[data.valueName]) {
        that.canteenForm[data.valueName] = data.path
      } else {
        that.canteenForm[data.valueName] += ',' + data.path
      }
      this.$refs.canteenForm.validateField(data.valueName)
      this.$emit('change', this.canteenForm)
    },
    // 批量上传删除某一张回调
    multiDelete (data) {
      if (this.canteenForm[data.valueName].indexOf(',' + data.path) >= 0) {
        this.canteenForm[data.valueName] = this.canteenForm[data.valueName].replace(',' + data.path, '')
      } else {
        this.canteenForm[data.valueName] = this.canteenForm[data.valueName].replace(data.path, '')
      }
      if (this.canteenForm[data.valueName].indexOf(',') === 0) {
        this.canteenForm[data.valueName] = this.canteenForm[data.valueName].substring(1)
      };
      this.$emit('change', this.canteenForm)
    }
  }
}
</script>

<style>
  .canteenRequired {
    color:red;
  }
  .canteenTooltip{
    background: #515b62;
    color: #606266;
    line-height: 20px;
    border-radius: 20px;
  }
</style>
